<soft-ds-card
  (click)="goToApplication(application)"
  class="group grid-item-container relative flex justify-center items-center"
  density="compact"
>
  <span
    class="application-icon px-4 py-2 rounded-xl w-16 h-16 text-center items-center content-center mt-1"
    [class]="
      showColor() && application?.color && !application?.disabled
        ? application?.color
        : 'bg-surface-tertiary dark:bg-surface-muted text-color'
    "
  >
    @if (application?.icon !== '') {
      <soft-icon
        [name]="$safeNavigationMigration(application?.icon)"
        class="text-3xl"
        [class]="application?.disabled ? 'text-lighter' : ''"
      />
    } @else {
      <i class="fa-regular fa-ban fa-3x"></i>
    }
  </span>
  <div class="flex flex-row w-full justify-center set-width">
    <span
      class="application-title self-baseline"
      [class]="application?.disabled ? 'text-lighter' : ''"
    >
      {{ $safeNavigationMigration(application?.name) | translate }}
    </span>
  </div>
  @if (application?.type === 'link') {
    <span
      class="absolute top-1 right-1 flex items-center gap-0.5 rounded-full bg-surface-secondary text-light px-1.5 py-px text-[9px] font-medium"
    >
      <i class="fa-regular fa-arrow-up-right-from-square text-[9px]"></i>
      Externer Link
    </span>
  } @else if (application?.badge) {
    <span
      class="absolute bottom-1 right-1 flex items-center gap-0.5 rounded-full bg-surface-secondary text-light px-1.5 py-px text-[9px] font-medium"
    >
      <i class="fa-regular fa-book text-[9px]"></i>
      {{ application?.badge }}
    </span>
  }
  @if (showMetadata()) {
    <div class="flex w-full justify-center text-[0.55rem]!">
      @if (application?.permission) {
        <soft-icon name="fa-regular fa-lock" class="mr-1" />
        {{ application?.permission }}
      } @else {
        <soft-icon name="fa-regular fa-lock-open" class="mr-1 text-danger" />
        <p class="text-danger">Keine Vergeben</p>
      }
    </div>
  }
  @if (canPin()) {
    <button
      type="button"
      [title]="pinned() ? 'Aus Navigation entfernen' : 'An Navigation anheften'"
      class="absolute top-1 left-1 flex items-center justify-center size-7 rounded-md bg-surface hover:bg-surface-tertiary transition-opacity cursor-pointer group-hover:opacity-100"
      [class.opacity-0]="!pinned()"
      [class.text-primary]="pinned()"
      (click)="pinChange.emit(!pinned()); $event.stopPropagation()"
    >
      <i
        class="fa-thumbtack text-xs transition-transform"
        [class.fa-solid]="pinned()"
        [class.fa-regular]="!pinned()"
        [class.rotate-45]="pinned()"
      ></i>
    </button>
  }
  @if (application?.type !== 'link') {
    <button
      type="button"
      class="absolute top-1 right-1 opacity-0 group-hover:opacity-100 flex items-center justify-center size-7 rounded-md bg-surface hover:bg-surface-tertiary transition-opacity cursor-pointer"
      (click)="openInNewTab(application, $event)"
      title="In neuem Tab öffnen"
    >
      <i class="fa-regular fa-arrow-up-right-from-square text-xs"></i>
    </button>
  }
</soft-ds-card>
